<template>
    <b-card header-tag="header">
        <template #header>
            <b-col sm="6" class="mx-0 px-0 my-1 py-0">
                {{ $t('prod_qualityprediction', { ns: 'production' }) }}
            </b-col>
            <b-col sm="6" class="mx-0 px-0 my-1 py-0 float-right">
                <b-button v-if="false" @click="copyItem" class="bgc_aux_normal"
                    ><font-awesome-icon icon="copy" size="1x" />
                </b-button>
            </b-col>
        </template>

        <div class="batch-assessment" v-if="assesmentExists">
            <div class="header">
                <div class="grade-block">
                    <span class="grade-label">Beoordeling</span>
                    <span
                        v-if="grade >= 0"
                        class="grade-value"
                        :class="gradeClass"
                        >{{ round(grade) }}</span
                    >
                    <span class="grade-sub">/ 10</span>
                </div>

                <div class="info-block">
                    <div class="trust-score">
                        <span class="label">Betrouwbaarheidsscore</span>
                        <span class="value">{{ assessment.trustScore }}</span>
                    </div>
                    <div class="explanation">
                        <span class="label">Toelichting</span>
                        <p class="value">{{ assessment.explanation }}</p>
                    </div>
                </div>
            </div>

            <div class="deviations">
                <h3>Afwijkingen</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Parameter</th>
                            <th>Werkelijk</th>
                            <th>Doel</th>
                            <th>Afwijking</th>
                            <th>Ernst</th>
                            <th>Impact</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(dev, index) in assessment.deviations"
                            :key="index"
                            :class="severityClass(dev.severity)"
                        >
                            <td>{{ dev.parameter }}</td>
                            <td>{{ round(dev.actual) }} {{ dev.unit }}</td>
                            <td>{{ round(dev.target) }} {{ dev.unit }}</td>
                            <td>{{ round(dev.deviationValue) }}</td>
                            <td>
                                <span class="badge">{{ dev.severity }}</span>
                            </td>
                            <td>{{ round(dev.impact) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else>
            <p>Geen kwaliteitsvoorspelling beschikbaar voor deze batch.</p>
        </div>
    </b-card>
</template>
<script>
import DateHelper from '../../models/DateHelper';
import { loadItem } from '../../models/DataHelper';
export default {
    name: 'QualityPredictionCard',
    data: function () {
        return {
            errorMessage: '',
            assessment: {},
            teller: 1
        };
    },
    components: {},
    model: {
        prop: 'visible',
        event: 'hide'
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        batchId: {
            type: Number,
            default: -1
        }
    },
    watch: {
        visible() {
            if (this.visible) this.getData();
        }
    },
    computed: {
        grade() {
            return this.assessment.grade ? this.assessment.grade : -1;
        },
        gradeClass() {
            if (
                this.assessment.grade === null ||
                this.assessment.grade === undefined
            ) {
                return 'grade--unknown';
            }
            if (this.assessment.grade >= 8) return 'grade--good';
            if (this.assessment.grade >= 6) return 'grade--moderate';
            return 'grade--poor';
        },
        assesmentExists() {
            return this.assessment != undefined;
        }
    },
    methods: {
        copyItem() {
            this.$emit('copy', this.assessment);
        },
        round(value) {
            return value ? value.toFixed(2) : '';
        },
        showDate(aDate) {
            return DateHelper.convertedToDateShort(aDate);
        },
        severityClass(severity) {
            return {
                'row--low': severity === 'Moderate',
                'row--moderate': severity === 'Serious',
                'row--high': severity === 'Critical'
            };
        },
        async getData() {
            if (this.batchId > -1) {
                this.assessment = await loadItem(
                    'production/loadBatchQualityPrediction',
                    {
                        batchId: this.batchId
                    },
                    this.$t
                );
            }
        }
    },
    mounted() {},
    async created() {
        await this.getData();
    }
};
</script>

<style scoped>
.batch-assessment {
    font-family: sans-serif;
    padding: 1.5rem;
    background: #f9f9f9;
    border-radius: 8px;
}

/* Header */
.header {
    display: flex;
    gap: 2rem;
    align-items: flex-start;
    margin-bottom: 2rem;
    background: #fff;
    border-radius: 8px;
    padding: 1.25rem;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.grade-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 90px;
}

.grade-label {
    font-size: 0.75rem;
    text-transform: uppercase;
    color: #888;
    margin-bottom: 0.25rem;
}

.grade-value {
    font-size: 2rem;
    font-weight: 700;
    line-height: 1;
}

.grade-sub {
    font-size: 0.85rem;
    color: #aaa;
}

.grade--good {
    color: #2e7d32;
}
.grade--moderate {
    color: #f57c00;
}
.grade--poor {
    color: #c62828;
}
.grade--unknown {
    color: #1621c0;
}

.info-block {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.trust-score {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.label {
    font-size: 0.75rem;
    text-transform: uppercase;
    color: #888;
    white-space: nowrap;
}

.trust-score .value {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
}

.explanation .value {
    margin: 0.25rem 0 0;
    font-size: 0.9rem;
    color: #444;
    white-space: pre-line;
    line-height: 1.5;
}

/* Deviations */
.deviations h3 {
    margin: 0 0 0.75rem;
    font-size: 1rem;
    color: #333;
}

table {
    width: 100%;
    border-collapse: collapse;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

th {
    background: #f0f0f0;
    text-align: left;
    padding: 0.6rem 0.9rem;
    font-size: 0.8rem;
    text-transform: uppercase;
    color: #666;
}

td {
    padding: 0.65rem 0.9rem;
    font-size: 0.9rem;
    border-top: 1px solid #f0f0f0;
    color: #333;
}

.badge {
    padding: 0.2rem 0.6rem;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
}

.row--low .badge {
    background: #e8f5e9;
    color: #2e7d32;
}
.row--moderate .badge {
    background: #fff3e0;
    color: #e65100;
}
.row--high .badge {
    background: #ffebee;
    color: #c62828;
}

.row--low td {
    background: #fafffe;
}
.row--moderate td {
    background: #fffdf7;
}
.row--high td {
    background: #fff8f8;
}
</style>
